import { useEffect, useState } from "react";
import { Badge, Button, Form, Modal, Alert, Spinner } from "react-bootstrap"; // Added Spinner
import Swal from "sweetalert2";
import "./AdminRequestsTab.css";
import { useAuth } from "../../../firebase/AuthProvider";
import {
    getPendingAdministrativeRequests,
    // approveAdministrativeTransactionRequest,
    // rejectAdministrativeTransactionRequest,
} from "../../../services/AdministrativeRequestServices/AdministrativeRequestService"
import { toast } from "react-toastify";
import { AdministrativeTransactionRequestResponse } from "../../../interfaces/adminRequests/AdministrativeTransactionRequest";
import { addUpdateTimeOff, approveRejectLeave, getLeaveTypes } from "../../../services/userServices/UserInfoService";
import { useNavigate } from "react-router-dom";
// removed approveRejectRequest import from here (moved into modal)
import ParticipantRequestModal from "./ParticipantRequestModal";
// removed unused GetTaskExtentionDetailsAsync import
import TaskExtensionModal from "./TaskExtensionModal";
import { ManagerRequest } from "../../../interfaces/UserInfo";
import NewAdminRequestModal from "./NewAdminRequestModal";
import { AppEvents } from "../../../events/events";


const Adminrequeststab: React.FC = () => {
    const [show, setShow] = useState(false); // Controls "Add New Request" modal visibility
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const { currentUser, currentUserInfo } = useAuth();
    const navigate = useNavigate();
    // Change requests type to the generic AdministrativeTransactionRequestResponse
    const [requests, setRequests] = useState<ManagerRequest[]>([]);
    const [error, setError] = useState<string | null>(null); // For fetching errors
    const [loading, setLoading] = useState(false);
    const userId = (currentUser as any)?.uid; // UID of the logged-in user

    // show only top N requests in the grid
    const TOP_COUNT = 4;
    const displayedRequests = requests.slice(0, TOP_COUNT);

    const [selectedRequestId, setSelectedRequestId] = useState<number | null>(null); // Renamed from selectedId for clarity
    const [showRejectionModal, setShowRejectionModal] = useState(false); // Renamed from showModal for clarity
    const [rejectionReason, setRejectionReason] = useState<string>(""); // <-- added state


    const [selectedRequest, setSelectedRequest] = useState<any>(null);
    const [viewModalOpen, setViewModalOpen] = useState(false);

    // --- New state for Task Extension flow ---
    const [showTaskExtensionModal, setShowTaskExtensionModal] = useState(false);
    const [selectedTaskExtensionRequestId, setSelectedTaskExtensionRequestId] = useState<number | null>(null);
    // removed taskExtensionRejectReason state (modal now owns it)




    const handleApprove = async (id: number) => {
        try {
            if (!currentUser) return;
            setLoading(true);
            const token = await currentUser.getIdToken();

            // Use your existing approveAdministrativeTransactionRequest
            const response = await approveRejectLeave(id, "approve", "", token);

            if (response.success) {
                toast.success(response.message);
                fetchData(); // Refresh data
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT'); // [!code ++] Updates the Sidebar
            } else {
                toast.error(response.message);
                setError(response.message); // Set a general error
            }
        } catch (error: any) {
            toast.error(error.message || "Internal Server Error");
        } finally {
            setLoading(false);
        }
    };

    const handleRejectClick = (id: number) => {
        setSelectedRequestId(id);
        setShowRejectionModal(true);
    };

    const handleViewClick = (req: any) => {
        setSelectedRequest(req);
        setViewModalOpen(true);
    };

    const handleViewClose = () => {
        setViewModalOpen(false);
        setSelectedRequest(null);
        // removed setRejectionReason since modal now owns rejection state
    };

    useEffect(() => {
        fetchData();
        // Re-fetch when userId or currentUser changes
    }, [userId, currentUser]);


    // fetchData was referenced but not defined — implement it to load pending requests
    const fetchData = async () => {
        if (!currentUser) return;
        setLoading(true);
        setError(null);
        try {
            const token = await currentUser.getIdToken();
            const res = await getPendingAdministrativeRequests(token, "", 1, 4);
            if(res.success){
                setRequests(res.data.items)
            }else{
                setError(res.message);
            }
        } catch (err : any) {
            console.error("Unexpected error fetching requests:", err);
            setError(err.message || "Failed to load requests.");
        } finally {
            setLoading(false);
        }
    };

    // reject confirm for admin (time-off / other non-participant) requests
    const handleRejectConfirm = async () => {
        if (!currentUser || selectedRequestId == null) return;
        if (!rejectionReason.trim()) {
            toast.warning("Please enter a reason for rejection.");
            return;
        }

        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            // use approveRejectLeave to perform backend reject (existing helper used for approve)
            const response = await approveRejectLeave(selectedRequestId, "reject", rejectionReason, token);

            if (response && response.success) {
                toast.success(response.message);
                setShowRejectionModal(false);
                setSelectedRequestId(null);
                setRejectionReason("");
                fetchData(); // refresh list after reject
                AppEvents.emit('UPDATE_ADMIN_REQUEST_COUNT');
            } else {
                const msg = response.message || "Failed to reject request.";
                toast.error(msg);
                console.error("Reject response:", response);
            }
        }  catch (error  : any) {
                toast.error(error.message || "Internal Server Error");
        } finally {
            setLoading(false);
        }
    };


    const openTaskExtensionModal = async (request: AdministrativeTransactionRequestResponse) => {
        setSelectedTaskExtensionRequestId(request.id);
        setShowTaskExtensionModal(true);
    };

    const closeTaskExtensionModal = () => {
        setShowTaskExtensionModal(false);
        setSelectedTaskExtensionRequestId(null);
    };

    return (
        <>
            <div className="common_content_inner mby_t_24">
                <div className="top border_tittle top_bar_flx mby_16">
                    <div className="top_bar_tittle">
                        <h2>Admin Requests</h2>
                    </div>
                    <div className="top_right_flx">
                        <Button onClick={handleShow} variant="primary" className="btn_sm">
                            Add New Request
                        </Button>
                    </div>
                </div>
                <div className="admin_request_grid">
                    {loading && <p>Loading requests...</p>}
                    {error && <Alert variant="danger">{error}</Alert>}
                    {!loading && !error && requests.length === 0 ? (
                        <div className="stats">
                            <p>No administrative requests awaiting your approval.</p>
                        </div>
                    ) : (
                        displayedRequests.map((request: AdministrativeTransactionRequestResponse) => (
                            <div className="admin_request_card" key={request.id}>
                                <div className="admin_request_card_txt">
                                    <h3 className="bold">
                                        {request.transactionType} - {request.requesterName}
                                    </h3>
                                    <div className="badge_flx">
                                        <div className="my_badge">
                                            <Badge
                                                bg={
                                                    request.status.toLowerCase() === "pending"
                                                        ? "warning"
                                                        : request.status.toLowerCase() === "approved"
                                                            ? "success"
                                                            : "danger"
                                                }
                                            >
                                                {request.status}
                                            </Badge>
                                        </div>
                                    </div>

                                    {/* --- CONDITIONAL RENDERING BASED ON TRANSACTION TYPE --- */}
                                    {request.transactionType === "Time-Off Request" && request.timeOffDetails ? (
                                        <div className="admin_date_flx">
                                            <div className="stats">
                                                <h3>Leave Type:</h3>{" "}
                                                <p>{request.timeOffDetails.typeOfLeave || "N/A"}</p>
                                            </div>
                                            <div className="stats">
                                                <h3>Start Date:</h3>{" "}
                                                <p>
                                                    {new Date(
                                                        request.timeOffDetails.timeOffStartDate
                                                    ).toLocaleDateString()}
                                                </p>
                                            </div>
                                            <div className="stats">
                                                <h3>End Date:</h3>{" "}
                                                <p>
                                                    {new Date(
                                                        request.timeOffDetails.timeOffEndDate
                                                    ).toLocaleDateString()}
                                                </p>
                                            </div>
                                            {request.timeOffDetails.comment && (
                                                <div className="stats">
                                                    <h3>Comment:</h3> <p>{request.timeOffDetails.comment}</p>
                                                </div>
                                            )}
                                        </div>
                                    ) : request.transactionType === "Time-Off Request" &&
                                        !request.timeOffDetails ? (
                                        <div className="admin_date_flx">
                                            <div className="stats">
                                                <p className="text-danger">
                                                    Time-Off details not available. Please check backend response.
                                                </p>
                                            </div>
                                        </div>
                                    ) : null}

                                    {(request.transactionType === "Task Deletion Request" ||  request.transactionType === "Task Extension Request") && (
                                        <div className="admin_date_flx">
                                            <div className="stats">
                                                <h3>Task:</h3>{" "}
                                                <p
                                                    className="text-primary underline cursor-pointer highlight_txt"
                                                    onClick={() =>
                                                        navigate(
                                                            `/task/${currentUserInfo?.organization.abbreviation}-${request.taskId}`
                                                        )
                                                    }
                                                >
                                                    {request.taskTitle || "N/A"}
                                                </p>
                                            </div>
                                            <div className="stats">
                                                <h3>Requested On:</h3>{" "}
                                                <p>
                                                    {request.requestTime
                                                        ? new Date(request.requestTime).toLocaleDateString()
                                                        : "N/A"}
                                                </p>
                                            </div>
                                        </div>
                                    )}
                                </div>

                                {/* --- BUTTONS SECTION --- */}
                                <div className="admin_request_card_btn mt-2">
                                    {request.participantRequest ? (
                                        // If participantRequest exists -> show View button
                                        <Button
                                            onClick={() => handleViewClick(request.participantRequest)}
                                            variant="primary"
                                            className="btn_sm"
                                        >
                                            View
                                        </Button>
                                    ) : request.transactionType === "Task Extension Request" ? (
                                        // For Task Extension requests show a View Details button that opens modal
                                        <Button
                                            onClick={() => openTaskExtensionModal(request)}
                                            variant="primary"
                                            className="btn_sm"
                                        >
                                            View Details
                                        </Button>
                                    ) : (
                                        // Otherwise -> Approve & Reject buttons
                                        <>
                                            <Button
                                                onClick={() => {
                                                    Swal.fire({
                                                        title: "Are you sure?",
                                                        text: `You are about to approve this ${request.transactionType} request.`,
                                                        icon: "warning",
                                                        showCancelButton: true,
                                                        confirmButtonColor: "#198754",
                                                        cancelButtonColor: "#d33",
                                                        confirmButtonText: "Yes, approve it!",
                                                    }).then((result) => {
                                                        if (result.isConfirmed) {
                                                            handleApprove(request.id);
                                                        }
                                                    });
                                                }}
                                                variant="success"
                                                className="btn_sm"
                                            >
                                                Approve
                                            </Button>
                                            <Button
                                                onClick={() => handleRejectClick(request.id)}
                                                variant="danger"
                                                className="btn_sm"
                                            >
                                                Reject
                                            </Button>
                                        </>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>

            </div>


           


            {/* Replace inline participant modal with imported component - pass currentUser and onCompleted to refresh list */}
            {
                viewModalOpen &&
                <ParticipantRequestModal
                    show={viewModalOpen}
                    onHide={handleViewClose}
                    selectedRequest={selectedRequest}
                    onCompleted={() => {
                        fetchData();
                        setViewModalOpen(false);
                    }}
                />
            }

            {/* Rejection modal (use react-bootstrap Modal instead of custom div) */}
            <Modal
                show={showRejectionModal}
                onHide={() => {
                    setShowRejectionModal(false);
                    setSelectedRequestId(null);
                    setRejectionReason("");
                }}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Rejection Reason</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Control
                            as="textarea"
                            rows={4}
                            value={rejectionReason} // wired to state
                            onChange={(e) => setRejectionReason(e.target.value)} // update state
                            placeholder="Enter reason for rejection..."
                        />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            setShowRejectionModal(false);
                            setSelectedRequestId(null);
                            setRejectionReason("");
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="danger"
                        onClick={handleRejectConfirm} // use the new handler
                        disabled={loading}
                    >
                        Reject
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Task Extension Details Modal (moved to separate component) */}
            {showTaskExtensionModal && selectedTaskExtensionRequestId &&

                <TaskExtensionModal
                    show={showTaskExtensionModal}
                    onHide={closeTaskExtensionModal}
                    selectedTaskExtensionRequestId={selectedTaskExtensionRequestId}
                    onCompleted={() => {
                        // refresh parent list and close modal
                        fetchData();
                        closeTaskExtensionModal();
                    }}
                />
            }

            {/* new request generation modal */}
            {show &&
                <NewAdminRequestModal
                    handleClose={handleClose}
                    show={show}
                />
            }
        </>
    );
};

export default Adminrequeststab;